import { PrimeReactPTOptions } from "primereact/api";
import { InputTextPassThroughMethodOptions } from "primereact/inputtext";
import { classNames } from "primereact/utils";

import { focusHoverField, invalidField, placeholder } from "./common";

export const inputtext: PrimeReactPTOptions["inputtext"] = {
  root: ({
    props,
    context,
    parent,
  }: InputTextPassThroughMethodOptions & { parent: InputTextPassThroughMethodOptions }) => {
    const invalid = props.invalid || parent?.props.invalid;
    const variant = props.variant ?? parent?.props.variant;

    return {
      className: classNames(
        "m-0 w-full",
        "text-urbe-gray text-sm border border-urbe-border bg-white",
        "dark:text-white/80 dark:bg-gray-900 dark:border-blue-900/40",
        "rounded",
        placeholder,
        focusHoverField,
        {
          [invalidField]: invalid,
          "bg-urbe-grayLight select-none pointer-events-none cursor-default": context.disabled,
          "bg-rdc-primaryLight": variant === "filled",
        },
        {
          "text-lg px-4 py-4": props.size == "large",
          "text-xs px-2 py-2": props.size == "small",
          "h-[40px] p-3": !props.size || typeof props.size === "number",
        },
      ),
    };
  },
};
